import Image from 'next/image';
import React from 'react';

import type { CardT } from '@/utils/contentfulTypes';

import { ContentfulTextContainer } from '../ContentfulTextContainer';

interface PersonalizedForEveryBodyProps {
  data: CardT[];
}

const PersonalizedForEveryBody: React.FC<PersonalizedForEveryBodyProps> = ({ data }) => {
  return (
    <section className="py-16 px-4 bg-alter-beige font-light md:px-20 md:py-24">
      <div className="width-1440">
        <h2 className="font-light text-[36px] leading-tight text-center md:text-left md:text-5xl">
          Personalized For Every Body
        </h2>
        <div className="grid grid-cols-1 gap-6 mt-20 smd:grid-cols-2 min-[1180px]:grid-cols-4">
          {data.map(({ headline, image, text }) => (
            <div key={headline} className="rounded-2xl bg-white overflow-hidden">
              <Image
                src={image.url}
                alt={headline}
                width={343}
                height={200}
                className="object-cover w-full"
              />
              <div className="p-8 pb-2">
                <h3 className="mt-2 font-light text-[24px] leading-tight lg:text-[24px] min-[1180px]:text-[20px] xl:text-[24px]">
                  {headline}
                </h3>
                <ContentfulTextContainer
                  markdown={text}
                  className="h-max mt-4 text-alter-black-80 [&_p]:text-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PersonalizedForEveryBody;
